import '../stylesheets/styles.scss';

import 'core-js';

import 'bootstrap-italia';
// import 'select2';

import './utils/imagesConfig';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/respimg/ls.respimg';

import 'slick-carousel';

import { PageData, Cookies, Keyboard, Logger, Responsive } from './utils'; // eslint-disable-line object-curly-newline
import { asyncSVG } from './libs/asyncSVG';
import { Header } from './components/header';
import { Footer } from './components/footer';
import { Banner } from './components/banner';
import { Page } from './components/page';
import { Carousel } from './components/carousel';
import { RichText } from './components/richt-text';
import { SquareGrid } from './components/square-grid';
import { MainSection } from './components/main-section';
import { Xjobs } from './components/xjobs';
import { NumberCards } from './components/number-cards';
import { HighlightGrid } from './components/highlight-grid';
import { RapidLinks } from './components/rapid-links';
import { SectionRow } from './components/section-row';
import { Tags } from './components/tags';
import { PeopleCards } from './components/people-cards';
import { SectionNameLists } from './components/section-name-lists';
import { HeadingNews } from './components/heading-news';
import { NewsDiscover } from './components/news-discover';
import { BackHistory } from './components/back-history';
import { DownloadStripe } from './components/download-stripe';
import { PreFooter } from './components/pre-footer';
import { FilterSection } from './components/filter-section';
import { NewsCard } from './components/news-card';
import { SeeMorePager } from './components/see-more-pager';
import { SpotlightSlider } from './components/spotlight-slider';
import { BoxEtica } from './components/box-etica';
import { Partner } from './components/partner';
import { Infografica } from './components/infografica';
import { FlippingCard } from './components/flipping-card';
import { SquareModal } from './components/square-modal';
import { BlocksFondi } from './components/blocks-fondi';
import { Faq } from './components/faq';
import { TeamSection } from './components/team-section';
import { Map } from './components/map';
import { SharingIcons } from './components/sharing-icons';
import { SearchResult } from './components/search-result';
import { BlocksPortfolio } from './components/blocks-portfolio';

if (!('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit'); // eslint-disable-line global-require
}

document.addEventListener('DOMContentLoaded', () => {
  // anche se non chiami init, questo garantisce che bootstrap-italia sia incluso
});

// load asyncronously the SVG sprite and inject it inside the page
asyncSVG();

// Crea l’istanza unica di BlocksFondi
const blocksFondiInstance = new BlocksFondi();

// Passa l’istanza a FilterSection
const filterSectionInstance = new FilterSection(blocksFondiInstance);

// initialize components
const Components = {
  header: new Header(),
  footer: new Footer(),
  banner: new Banner(),
  carousel: new Carousel(),
  richText: new RichText(),
  squareGrid: new SquareGrid(),
  mainSection: new MainSection(),
  xjobs: new Xjobs(),
  numberCards: new NumberCards(),
  highlightGrid: new HighlightGrid(),
  rapidLinks: new RapidLinks(),
  sectionRow: new SectionRow(),
  tags: new Tags(),
  peopleCards: new PeopleCards(),
  sectionNameLists: new SectionNameLists(),
  headingNews: new HeadingNews(),
  newsDiscover: new NewsDiscover(),
  backHistory: new BackHistory(),
  downloadStripe: new DownloadStripe(),
  preFooter: new PreFooter(),
  newsCard: new NewsCard(),
  seeMorePager: new SeeMorePager(),
  spotlightSlider: new SpotlightSlider(),
  boxEtica: new BoxEtica(),
  partner: new Partner(),
  infografica: new Infografica(),
  flippingCard: new FlippingCard(),
  squareModal: new SquareModal(),
  blocksFondi: blocksFondiInstance,
  faq: new Faq(),
  teamSection: new TeamSection(),
  map: new Map(),
  sharingIcons: new SharingIcons(),
  searchResult: new SearchResult(),
  blocksPortfolio: new BlocksPortfolio(),
  filterSection: filterSectionInstance,
};

const PageInstance = new Page(); // must be initialized after the other components

export {
  PageInstance,
  Components,
  PageData,
  Cookies,
  Keyboard,
  Logger,
  Responsive,
};
